import React, { Component } from "react"

import { renderIcons } from "./../Utils/Utils.js"

const renderHeading = (children, className, size, icons, icons_size) => {
  switch (size) {
    case 1:
      return (
        <h1 className={className}>
          {children} {icons && renderIcons(icons, icons_size)}
        </h1>
      )
    case 2:
      return (
        <h2 className={className}>
          {children} {icons && renderIcons(icons, icons_size)}
        </h2>
      )
    case 3:
      return (
        <h3 className={className}>
          {children} {icons && renderIcons(icons, icons_size)}
        </h3>
      )
    case 4:
      return (
        <h4 className={className}>
          {children} {icons && renderIcons(icons, icons_size)}
        </h4>
      )
    case 5:
      return (
        <h5 className={className}>
          {children} {icons && renderIcons(icons, icons_size)}
        </h5>
      )
    case 6:
      return (
        <h6 className={className}>
          {children} {icons && renderIcons(icons, icons_size)}
        </h6>
      )
    default:
      return null
  }
}

class Heading extends Component {
  render() {
    const { children, className, size, icons, icons_size } = this.props

    return renderHeading(children, className, size, icons, icons_size)
  }
}

export default Heading
